'use client';

import React, { useEffect, useRef } from 'react';
import { cn } from '../../utils/cn/cn';

export type DialogProps = React.HTMLAttributes<HTMLDialogElement> & {
  isOpen: boolean;
  /** Callback fired on dialog close */
  onClose: () => void;
};

/**
 * A dialog implementing the visual layout of the empiriecom design system
 */
const Dialog = ({ children, isOpen = false, onClose, className, ...props }: DialogProps) => {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (isOpen) {
      ref.current?.showModal();
    } else {
      ref.current?.close();
    }
  }, [isOpen]);

  return (
    <dialog
      className={cn(
        `backdrop:bg-color-backdrop bg-color-background-base m-0 min-h-full min-w-full max-w-[900px] ${isOpen ? 'flex md:m-auto md:h-fit md:min-h-0 md:min-w-0' : ''} flex-col`,
        className,
      )}
      ref={ref}
      onCancel={onClose}
      {...props}
    >
      {children}
    </dialog>
  );
};

Dialog.displayName = 'Dialog';

export { Dialog };
